<template>
  <span :class="['label', 'label-' + theState]">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    state: {
      type: String,
    },
    permit: {
      type: Boolean,
      default: true,
    },
  },
  // props: ["state"],
  computed: {
    theState() {
      if (this.permit == true) {
        return this.state;
      }
      const dealeds = ["prepared", "processed", "purchased"];
      const dealings = ["preparing", "processing", "purchasing"];
      if (dealeds.includes(this.state)) {
        return "dealed";
      } else if (dealings.includes(this.state)) {
        return "dealing";
      } else {
        return this.state;
      }
    },
  },
};
</script>

<style scoped>
.label {
  font-size: 10px;
  padding: 2px 3px;
  color: #fff;
  border-radius: 4px;
}
.label-newly {
  background-color: #7ec0ee;
}
.label-confirming {
  background-color: #7ec0ee;
}
.label-placed {
  background-color: #339966;
}
.label-pending {
  background-color: #999900;
}
.label-preparing {
  background-color: #6699cc;
}
.label-prepared {
  background-color: #669999;
}
.label-processing {
  background-color: #6666cc;
}
.label-processed {
  background-color: #666699;
}

.label-purchasing {
  background-color: #9999ff;
}
.label-purchased {
  background-color: #436eee;
}
.label-partially {
  background-color: #009999;
}
.label-finished {
  background-color: #006666;
}
.label-finish {
  background-color: #006666;
}
.label-forout {
  background-color: #c0e619;
}

.label-shipped {
  background-color: #99cccc;
}
.label-returned {
  background-color: #666633;
}
.label-canceled {
  background-color: #cccccc;
  color: #333;
}
.label-cancel {
  background-color: #cccccc;
  color: #333;
}
.label-dispatched {
  background-color: #a0b46f;
}
/*c*/
.label-gived {
  background-color: #999900;
}
.label-accepted {
  background-color: #99cccc;
}
.label-holding {
  background-color: #9999ff;
}
.label-holded {
  background-color: #9999cc;
}
.label-untrod {
  background-color: #666633;
}
.label-dealed {
  background-color: #91c957;
}
.label-checked {
  background-color: #0d3a8d;
}
/*附加*/
.label-dealing {
  background-color: #46bbdc;
}
.label-outed {
  background-color: #f79b99;
}

/* 报损 */
/* newly: '新的', agreed: '同意',rejected: '拒绝',outed: '出库' */
.label-agreed {
  background-color: #67c23a;
}
.label-rejected {
  background-color: #e93131;
}
/* allocateWorkflowState: {
      applying: '新的',
      outed: '出库',
      rejected: '拒绝',
      ined: '入库',
      picking: '待出库',
      pushing: '待入库',
    }, */

.label-applying {
  background-color: #7ec0ee;
}
.label-ined {
  background-color: #67c23a;
}
.label-picking {
  background-color: #909399;
}
.label-pushing {
  background-color: #e6a23c;
}

/* 'newly', 'outed', 'finished' */
</style>